import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/LockKey.es.js";
const e = o.forwardRef((c, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...c, weights: a }));
e.displayName = "LockKeyIcon";
const n = e;
export {
  n as LockKey,
  e as LockKeyIcon
};
